/**
 * @generated SignedSource<<6a1abfcbdebecf6eda90cda980dac167>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedShopByModuleItem_item$data = {
  readonly cta: string | null;
  readonly description: string | null;
  readonly imageHeight: string | null;
  readonly imageUrl: string | null;
  readonly imageWidth: string | null;
  readonly linkData: {
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedModuleItemTile_linkData">;
  };
  readonly title: string | null;
  readonly " $fragmentType": "HpSharedShopByModuleItem_item";
};
export type HpSharedShopByModuleItem_item$key = {
  readonly " $data"?: HpSharedShopByModuleItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedShopByModuleItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedShopByModuleItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageHeight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageWidth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedModuleItemTile_linkData"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "d95b07afac7805e20180b4d14a452c46";

export default node;
